import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import Auth from '../../auth'
import history from '../../history'

import {
  getActiveLanguage,
  setActiveLanguage
} from 'react-localize-redux'

import {
  SIGNUP_SUCCESS,
  SIGNUP_FAIL,
  LOGIN_SUCCESS
} from '../../common/constants'

import {
  signup,
  login,
  setProfile,
  setAuthToken,
  setAuthError,
  userGet,
  resetSignupErrors,
  resetMfaState,
  requestOtpVerification,
  sendOtp,
  verifyOtp
} from '../../redux/actions'

/* Components */
import SignupForm from '../../components/signup'

const auth = new Auth()

class SignupPage extends Component {

  componentWillMount() {
    this.props.reset()
    this.props.resetMfaState()
  }

  render() {
    const {
      translate,
      languages,
      signup,
      error,
      activeLanguage,
      resetMfaState,
      requestOtpVerification,
      sendOtp,
      verifyOtp,
      mfaVerificationRequested,
      mfaVerified
    } = this.props


    return (
      <SignupForm
        languages={languages}
        signup={signup}
        translate={translate}
        signuperror={error}
        activeLanguage={activeLanguage}
        resetMfaState={resetMfaState}
        requestOtpVerification={requestOtpVerification}
        sendOtp={sendOtp}
        verifyOtp={verifyOtp}
        mfaVerificationRequested={mfaVerificationRequested}
        mfaVerified={mfaVerified}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  languages: state.localeReducer.languages,
  translate: getTranslate(state.localeReducer),
  error: state.authReducer.error,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  mfaVerificationRequested: state.mfaReducer.mfaVerificationRequested,
  mfaVerified: state.mfaReducer.mfaVerified,
  ...state
})

const mapDispatchToProps = (dispatch, props) => ({
  signup: (form) => {
    const redirectToLogin = () => {
      dispatch(setAuthError(false))
      history.replace('/login')
      return { navigated: true }
    }

    dispatch(resetSignupErrors())
    return dispatch(signup(form)).then((signupresponse) => {
      switch (signupresponse.type) {
        case SIGNUP_SUCCESS:
          if (signupresponse.payload.data.success) {
            return dispatch(login({
              username: form.emailaddress,
              password: form.password,
              grant_type: 'password'
            })).then(response => {
              if (response.type !== LOGIN_SUCCESS || !response.payload.data.success) {
                return redirectToLogin()
              }

              const { access_token, refresh_token, id, name, roles, rolenames, customerid, customer } = response.payload.data
              const expires = new Date(response.payload.data['.expires']).getTime()

              dispatch(setAuthToken({
                access_token,
                refresh_token,
                expires
              }))

              auth.handleAuthentication({
                access_token,
                refresh_token,
                expires
              })

              dispatch(setProfile({ id, name, roles, rolenames, customerid, customer }))
              dispatch(userGet(id, true))
              history.replace('/jobs')
              return { navigated: true }
            }).catch(redirectToLogin)
          } else {
            dispatch(setAuthError(signupresponse.payload.data.errors))
            throw new Error(signupresponse.payload.data.errors || 'Unable to create your account.')
          }
        case SIGNUP_FAIL:
          dispatch(setAuthError(signupresponse.payload.data.errors))
          throw new Error(signupresponse.payload.data.errors || 'Unable to create your account.')
        default:
          throw new Error('Unable to create your account.')
      }
    }).catch(error => {
      dispatch(setAuthError(error.message || true))
      throw error
    })
  },
  setLanguage: (language) => {
    dispatch(setActiveLanguage(language))
  },
  reset: () => {
    dispatch(setAuthError(false))
  },
  requestOtpVerification: (data) => {
    dispatch(requestOtpVerification({
      emailAddress: data.emailAddress,
      contactNumber: data.contactNumber,
      tempData: null
    }))
  },
  resetMfaState: () => {
    dispatch(resetMfaState())
  },
  sendOtp: (request) => {
    return dispatch(sendOtp({
      method: request.method,
    }))
  },
  verifyOtp: (form) => {
    return dispatch(verifyOtp({
      otp: form.otp,
    }));
  }
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  stateProps.valid = !stateProps.authReducer.error
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SignupPage)
